import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import AdminNewsComponent from '../../components/AdminNewsComponent';
import UserNewsComponent from '../../components/UserNewsComponent';
import { Paper } from '@mui/material';

export default function NewsPage() {
    const { t } = useTranslation();
    const { info, emulation } = useSelector(state => state.user);
    const role_id = emulation.length ? emulation[emulation.length - 1].info.role_id : info.role_id;

    return (
        <Fragment>
            <h2 className="container-header"> {t('news.title')} </h2>
            {(role_id === 1 || role_id === 2) && (
                <Paper elevation={0}>
                    <AdminNewsComponent />
                </Paper>
            )}
            {(role_id === 3 || role_id === 4) && (
                <Paper elevation={0}>
                    <UserNewsComponent />
                </Paper>
            )}
        </Fragment>
    );
}
